import React from 'react';
import { QuestionRendererProps } from './QuestionRenderer';

const DropdownRenderer: React.FC<Omit<QuestionRendererProps, 'questionNumber'>> = ({
  question,
  value,
  onChange,
  error,
}) => {
  const options = question.options || [];

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onChange(e.target.value || undefined);
  };

  return (
    <select
      value={value || ''}
      onChange={handleChange}
      className={`w-full px-4 py-3 border rounded-lg transition-colors ${
        error
          ? 'border-red-300 focus:border-red-500 focus:ring-red-500'
          : 'border-gray-300 focus:border-blue-500 focus:ring-blue-500'
      } focus:outline-none focus:ring-2 bg-white`}
      aria-invalid={!!error}
      aria-describedby={error ? `${question.id}-error` : undefined}
    >
      <option value="">-- Select an option --</option>
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
};

export default DropdownRenderer;
